import { Box, Flex } from '@chakra-ui/react';
import InfiniteScroll from 'react-infinite-scroll-component';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import useApiInfinite from '@/hooks/useApiInfinite';
import s from './styles.module.scss';
import AppLoading from '@/components/AppLoading';
import { WalletContext } from '@/contexts/wallet-context';
import ProposalItem from './item';
import { ClientOs } from '@/enums/client';
import { detectClientOs } from '@/utils/client';
import ListTable, { ColumnProp } from '@/components/ListTable';
import { IMutualFriend } from '@/interfaces/flag-tw';
import { useSelector } from 'react-redux';
import { selectCommonReducer } from '@/state/common';
import { getListProposal } from '@/services/governor';

const LIMIT_PAGE = 20;

const ListProposal = ({ profile }: any) => {
  const infiniteScrollRef = useRef<any>(null);
  const [_, setLoading] = useState(false);
  const { addressL2 } = useContext(WalletContext);
  const clientOs = detectClientOs();
  const needReload = useSelector(selectCommonReducer).needReload;

  useEffect(() => {
    refresh();
  }, [needReload]);

  const renderLoading = () => (
    <div className={s.loadingMore}>
      <AppLoading />
    </div>
  );

  const fetchHoldingKeys = async ({
    page,
    limit,
  }: {
    page: number;
    limit: number;
  }) => {
    try {
      setLoading(true);
      const res =
        (await getListProposal({
          twitter_id: profile?.twitterId,
          address: addressL2 as any,
          page,
          limit,
        })) || [];

      return res;
    } catch (err: unknown) {
      console.log('Failed to fetch tokens owned');
    } finally {
      setLoading(false);
    }
  };

  const {
    dataInfinite,
    loadMore,
    refresh,
    isLoadingMore,
    isReachingEnd,
    isRefreshing,
  } = useApiInfinite(
    fetchHoldingKeys,
    { limit: LIMIT_PAGE },
    { revalidateOnFocus: true }
  );

  const columns: ColumnProp[] = useMemo(() => {
    return [
      {
        id: 'index',
        label: '#',
        labelConfig: {
          color: '#898989',
          fontSize: '12px',
          bgColor: 'transparent',
          textAlign: 'right',
        },
        config: {
          borderBottom: 'none',
        },
        render(data: IMutualFriend, extraData: any, index: number) {
          return <Flex gap={2} alignItems={'center'}></Flex>;
        },
      },
      {
        id: 'description',
        label: 'Title',
        labelConfig: {
          color: '#898989',
          fontSize: '12px',
          bgColor: 'transparent',
          textAlign: 'right',
        },
        config: {
          borderBottom: 'none',
        },
        render(data: IMutualFriend) {
          return (
            <Flex gap={2} justifyContent={'flex-end'} color={'#000000'}></Flex>
          );
        },
      },
      {
        id: 'status',
        label: 'Status',
        labelConfig: {
          color: '#898989',
          fontSize: '12px',
          bgColor: 'transparent',
          textAlign: 'right',
        },
        config: {
          borderBottom: 'none',
        },
        render(data: IMutualFriend) {
          return (
            <Flex gap={2} justifyContent={'flex-end'} color={'#000000'}></Flex>
          );
        },
      },
    ];
  }, []);

  return (
    <Box className={s.container}>
      <InfiniteScroll
        ref={infiniteScrollRef}
        className="disable-scrollbar-x"
        height={
          clientOs === ClientOs.Ios
            ? 'calc(100dvh - 200px)'
            : 'calc(100dvh - 180px)'
        }
        dataLength={dataInfinite?.length || 500}
        hasMore={!isReachingEnd}
        loader={isLoadingMore && renderLoading()}
        refreshFunction={refresh}
        pullDownToRefresh
        pullDownToRefreshThreshold={50}
        next={loadMore}
        style={{ marginLeft: '16px', marginRight: '16px' }}
      >
        {isRefreshing && renderLoading()}
        {/*{(dataInfinite || []).map((item: any) => (<BlastItem data={item}/>))}*/}
        <ListTable
          data={dataInfinite}
          columns={columns}
          showEmpty={!isRefreshing}
          emptyLabel={'There is no data'}
          initialLoading={false}
          noHeader={true}
          ItemListComponent={(row, extraData, columns, i) => {
            return <ProposalItem data={row} profile={profile} key={i} />;
          }}
        />
      </InfiniteScroll>
    </Box>
  );
};

export default ListProposal;
